export const servicios = {
    text1: "Lista de solicitações de serviço",
    text2: "Solicitações feitas pelos seus clientes",
    text3: "Lista de solicitações",
    text4: "Todas",
    text5: "Pendentes",
    text6: "Aprovadas",
    text7: "Recusadas",
    text8: "Pagas",
    text9: "Serviço",
    text10: "Cliente",
    text11: "Telefone",
    text12: "Criada",
    text13: "Status",
    text14: "Ver pedido",
    text15: "Solicitação de serviço.",
    text16: "Dados da solicitação",
    text17: "Data da solicitação:",
    text18: " às",
    text19: "Informações do serviço",
    text20: "Preço:",
    text21: "Preço por:",
    text22: "Categoria:",
    text23: "Fornecedor:",
    text24: "Fornecedor:",
    text25: "Serviço interno",
    text26: "Informações do serviço",
    text27: "Serviço não encontrado",
    text28: "Informações do solicitante",
    text29: "Telefone:",
    text30: "E-mail:",
    text31: "Tipo de documento:",
    text32: "Número do documento:",
    text33: "Fechar",
    text34: "Recusar",
    text35: "Aprovar",
    text36: "Confirmar pagamento",
    text37: "Recusar solicitação",
    text38: "Aprovar solicitação",
    text39: "Confirmar o pagamento do solicitante",
    text40: "Tem certeza de que deseja recusar a solicitação de serviço?",
    text41: "Entre em contato com o solicitante do serviço antes de aprovar a solicitação",
    text42: "Ao confirmar o pagamento do solicitante, o processo será concluído",
    text43: "Recusar",
    text44: "Aprovar solicitação",
    text45: "Já confirmei o pagamento",
    text46: "Cancelar",
    text47: "Atualizado com sucesso.",

    // New labels  

    p1: `Hoje`,
    p2: `Serviço solicitado`,
    p3: `Hóspede`,
    p4: `Data da solicitação`,
    p5: `Ainda não há solicitações de serviço`,
    p6: `Você ainda não configurou nenhum serviço.`,
    p7: `Configure os serviços da sua acomodação para que seus hóspedes possam fazer solicitações`,
    p8: `Configurar serviço`,
    p9: `Consulta`,
    p10: `Descartar solicitação de serviço`,
    p11: `Tem certeza? Os dados da solicitação serão perdidos`,
    p12: `Descartar`,
    p13: `Solicitação de serviço excluída com sucesso`,
    p14: "Envie até 3 fotos do seu serviço",
    p15: "Arraste e solte para enviar fotos",
    p16: "...ou clique para selecionar fotos do seu computador",
    p17: "Clique para buscar uma imagem na sua galeria"
};
